import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import UploadImage from "../../components/UploadImage";
import "../../styles/Edit.css";
import backendUrl from "../../BackendUrl";

const EditClass = () => {
  const { id } = useParams(); // Grab the ID from the URL
  const navigate = useNavigate();
  const [classData, setClassData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const adminToken = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/vehicles/get-class/${id}`);
        setClassData(response.data); // Load data for the specific class
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch class data. Please try again later.");
        setLoading(false);
      }
    };

    fetchClassData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setClassData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${backendUrl}/api/vehicles/update-class/${id}`, classData, {headers: {Authorization: `Bearer ${adminToken}`,},});
      setClassData(response.data);
      alert("Class updated successfully!");
    } catch (error) {
      alert("Failed to update class. Please try again later.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this class?")) {
      try {
        await axios.delete(`${backendUrl}/api/vehicles/delete-class/${id}`, {headers: {Authorization: `Bearer ${adminToken}`,},});
        alert("Class deleted successfully.");
        navigate("/edit-website");
      } catch (error) {
        alert("Failed to delete the class. Please try again later.");
      }
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p className="error">{error}</p>;
  }

  return (
    <div className="edit-class-container">
      {/* Left Section: Form */}
      <div className="edit-form">
        <h2>Edit Class</h2>
        <form onSubmit={handleSubmit}>
          <label>
            Class Name:
            <input
              type="text"
              name="class"
              value={classData?.class || ""}
              onChange={handleInputChange}
            />
          </label>
          <label>
            Description:
            <textarea
              name="description"
              value={classData?.description || ""}
              onChange={handleInputChange}
              rows={4}
            />
          </label>

          {/* READY TOGGLE */}
          <label className="toggle">
            <input
              type="checkbox"
              name="ready"
              checked={classData?.ready || false}
              onChange={(e) =>
                setClassData((prev) => ({
                  ...prev,
                  ready: e.target.checked,
                }))
              }
            />
            <span>Ready</span>
          </label>

          <button type="submit">Save Changes</button>
        </form>
        <UploadImage 
          uploadUrl="/api/vehicles/upload-class"
          id={id}
          onUploadSuccess={(data) => console.log("Uploaded:", data)}
        />
        {/* Delete button */}
        <button
          type="button"
          onClick={handleDelete}
          style={{ backgroundColor: "red", color: "white", marginTop: "1rem" }}
        >
          Delete Class
        </button>
      </div>

      {/* Right Section: Display */}
      <div className="display-section">
        {classData?.classImg && (
          <div className="image-container">
            <img src={classData.classImg} alt="Class" />
            <div className="image-title">{classData?.class || "N/A"}</div>
          </div>
        )}
        <p className="description">{classData?.description || "No description available"}</p>
      </div>
    </div>
  );
};

export default EditClass;